import React from 'react';

import { OccupationForm } from './components/OccupationForm';

import { LocalPopup } from 'js/components/common/Popup';

import style from './OccupationPopup.scss';

export const OccupationPopup = () => {
    return (
        <LocalPopup
            isModal
            className={style.popup}
            classNames={{ inner: style.inner, container: style.container }}
        >
            <OccupationForm />
        </LocalPopup>
    );
};
